import React from "react";

export function Monogram({ size = 44, withText = true, compact = false }) {
  // Serif BA monogram. "B" in charcoal, "A" accent stroke in gold.
  return (
    <div className="flex items-center gap-3" data-testid="logo-monogram">
      <div
        className="relative flex items-center justify-center border border-border-light bg-surface"
        style={{ width: size, height: size }}
      >
        <span
          className="font-serif leading-none text-charcoal"
          style={{ fontSize: size * 0.56 }}
        >
          B
        </span>
        <span
          className="font-serif leading-none text-gold -ms-[4px]"
          style={{ fontSize: size * 0.56 }}
        >
          A
        </span>
        <span className="absolute bottom-[6px] start-[6px] w-2 h-px bg-gold" />
      </div>
      {withText && (
        <div className="leading-tight">
          <div className={`font-serif ${compact ? "text-sm" : "text-base"} text-charcoal`}>
            Boudiaf Aimad
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-charcoal-muted">
            Notaire · Alger
          </div>
        </div>
      )}
    </div>
  );
}

export default Monogram;
